const Config = {
	googleMapsKey : 'AIzaSyBfRnwR6jAuqhzYXqe4GkuUD3fW0k2-5_g',
	googleRecaptchSiteKey : '6LfhG1QUAAAAACAVuR2LxsifZIRyFOpKIHyQHh8q',
	googleAnalyticsCode : 'G-JPGYG4ZSQR',
	googleTagCode		: 'GTM-MQWZ6FH2'
}

export default Config
